<template>
  <div class="singleShowingObject pt-50" v-if="currentListing">
    <HeaderNavigation v-bind:title="currentListing.address"/>
    <div class="container pt-75">
      <!-- pris -->
      <ul class="home-links object-info">
        <li>
          <span>Utgångspris</span>
          <span class="bold mt-5" v-show="currentListing.price">{{ $root.formatPrice(currentListing.price) }} kr</span>
          <span class="bold mt-5 opaque-60" v-show="!currentListing.price">saknas</span>

          <span class="mt-15">Högsta bud</span>
          <span class="bold mt-5" v-show="currentListing.maxBid">{{ $root.formatPrice(currentListing.maxBid) }} kr</span>
          <span class="bold mt-5 opaque-60" v-show="!currentListing.maxBid">saknas</span>
        </li>
        <li>
          <span>Nästa visning</span>
          <span class="bold mt-15" v-show="!currentListing.nextShowing.date">saknas</span>
          <span class="bold mt-15" v-show="currentListing.nextShowing.date">{{currentListing.nextShowing.date}}</span>
          <span class="bold mt-5 opaque-60" v-show="currentListing.nextShowing.time">{{ currentListing.nextShowing.time }}</span>
        </li>
      </ul>

      <!--- säljare sms:a / maila alla säljare -->
      <div class="grid2col mt-35 mb-15">
        <div class="all-caps">Säljare</div>
        <div class="flex justify-between"><img alt="sms-multi"  class="ml-50" @click="sms('sellers')" src="../../assets/icons/sms_multi.svg"><img alt="mail-multi" src="../../assets/icons/mail_multi.svg" @click="mail('sellers')" class="mr-15"></div>
      </div>

      <!-- säljare -->
      <ul>
        <li class="p15 bg-white mb-2 shadow" v-for="seller in currentListing.sellers" v-bind:key="seller.id">
          <div class="grid2col">
            <div>{{ seller.firstname }} {{ seller.lastname }}</div>
            <div class="flex justify-between"><a :href="`tel:${seller.cellphone ? seller.cellphone : seller.phone}`"><img alt="icon" src="../../assets/icons/phone.svg"></a><img alt="icon" src="../../assets/icons/sms.svg" @click="sms(seller)"><img alt="icon" src="../../assets/icons/mail.svg" @click="mail(seller)"> </div>
          </div>
          <div v-if="seller.subcustomers" class="mt-20">
            <div class="grid2col mb-15" v-for="(contactperson, index) in seller.subcustomers" :key="index">
              <div class="fs-14">{{ contactperson.firstname }} {{ contactperson.lastname }}</div>
              <div class="flex justify-between"><a :href="`tel:${contactperson.cellphone ? contactperson.cellphone : contactperson.phone}`"><img alt="icon" src="../../assets/icons/phone.svg"></a><img alt="icon" src="../../assets/icons/sms.svg" @click="sms(contactperson)"><img alt="icon" src="../../assets/icons/mail.svg" @click="mail(contactperson)"> </div>
            </div>
          </div>
        </li>
      </ul>

      <!-- Visningar -->
      <p class="mt-35 mb-15 all-caps">Visningar</p>
      <button class="width-100 outline mb-30" @click="newShowing">ny visning</button>

      <div v-if="showings">
          <ShowingCard v-for="showing in showings" v-bind:key="showing.id" :showing="showing"></ShowingCard>
      </div>
    </div>
    <Modal>
      <component v-bind:is="activeComponent"/>
    </Modal>
    <Footer/>
  </div>
  <div v-else>
    <spinner/>
  </div>

</template>

<script>
import Footer from '@/components/Footer.vue'
import HeaderNavigation from '@/components/HeaderNavigation';
import Modal from '../../components/Modal';
import sendSmsOrMail from '../../components/forms/generic/sendSmsOrMail';
import spinner from '../../components/spinner';

// forms
import newShowing from '../../components/forms/visningar/newShowing';

// Showing
import ShowingCard from '@/components/showing/ShowingCard';

export default {
  name: 'SingleShowingObject',
  data() {
    return {

    }
  },
  computed: {
    currentListing() {
      return this.$store.state.showing.currentListingWithActiveShowing;
    },
    showings() {
      return this.$store.state.showing.currentListingWithActiveShowing.showings;
    },
    activeComponent() {
      return this.$store.state.activeComponent;
    }
  },
  components: {
    ShowingCard,
    HeaderNavigation,
    Footer,
    Modal,
    // Forms
    newShowing,
    spinner
  },
  methods: {
    showModal() {
      this.$root.modalOpen = true;
    },
    newShowing() {
      this.$store.commit('STORE_ACTIVE_COMPONENT', newShowing);
      this.showModal();
    },
    mail(data) {
      this.$store.commit('STORE_SMS_MAIL_WHICH_SERVICE', 'showing');

      let receiverData = {
        deliveryWay: "email",
        receivers : [],
        subject: '',
        message: ''
      };
      // handle mail ALL sellers
      if (data === "sellers") {
        receiverData.receivers = this.$store.getters.getSellersAndExtraContactPersons;
      } else {
        receiverData.receivers.push(data);
      }
      this.$store.commit('STORE_SEND_SMS_OR_MAIL_CONTACT_DATA', receiverData);

      this.$store.commit('STORE_ACTIVE_COMPONENT', sendSmsOrMail);
      this.$root.modalOpen = true;
    },
    sms(data) {
      this.$store.commit('STORE_SMS_MAIL_WHICH_SERVICE', 'showing');
      let receiverData = {
        deliveryWay: "sms",
        receivers : []
      };

      // handle sms ALL sellers, or bidders
      if (data === "sellers") {
        receiverData.receivers = this.$store.getters.getSellersAndExtraContactPersons;
      } else {
        receiverData.receivers.push(data);
      }
      this.$store.commit('STORE_SMS_MAIL_DELIVERYWAY', 'sms');
      this.$store.commit('STORE_SMS_MAIL_RECIEVERS', receiverData.receivers);

      this.$store.commit('STORE_ACTIVE_COMPONENT', sendSmsOrMail);
      this.$root.modalOpen = true;
    },
  },
  created() {
    // To clear STORE_ACTIVE_COMPONENT state
    this.$root.abortForm();

    this.$store.dispatch('storeCurrentUserMessagingTemplates');
    this.$store.dispatch('showing/storeShowingDataForSelectedListing', { listingId: this.$route.params.id });
  }
}
</script>

<style>
.object-info li {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
</style>
